<template>
  <div>
    <v-expansion-panels
        v-model='panel'
        multiple
    >
      <v-expansion-panel>
        <v-expansion-panel-header

        ><h3>Информация о товаре</h3></v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <v-row>
            <v-col cols='12' :md='4' :sm='4'>
              <v-select v-if='!isTTN'
                        label='Товар'
                        outlined
                        item-text='Name'
                        :rules='[required]'
                        item-value='Id'
                        v-model='item.ProductId'
                        :items='products'
                        :disabled='!input.isEdit'
                        dense
                        @input='productChange'
              />
              <v-text-field v-if='isTTN'
                            :rules='[required]'
                            label='Товар'
                            item-value='Id'
                            :readonly='isTTN'
                            v-model='item.Name'
                            outlined
                            :disabled='!input.isEdit'
                            dense
              />
            </v-col>
            <v-col cols='12' sm='4' md='4'>
              <v-text-field
                  label='Ставка НДС'
                  :readonly='isTTN || thisContractHasVat === false'
                  :disabled='!input.isEdit'
                  v-model='item.VATRate'
                  :rules='[maxRate]'
                  @input='resetItem'
                  type='number'
                  outlined
                  dense
              />
            </v-col>
            <v-col cols='12' :md='4' :sm='4'>
              <v-text-field
                  :rules='[rulesDensity,required]'
                  outlined
                  filled
                  v-model='item.Density'
                  :disabled='!input.isEdit'
                  label='Плотность'
                  type='number'
                  dense
                  @input='density'
              />
            </v-col>
            <v-col cols='12' md='6' sm='6'>
              <v-text-field
                  outlined
                  type='number'
                  :rules='[rulesTons,required]'
                  :disabled='!input.isEdit'
                  v-model='item.AmountInTonne'
                  label='Тонна'
                  dense
                  @input='tons'
              />
            </v-col>
            <v-col cols='12' md='6' sm='6'>
              <v-text-field
                  v-model='item.AmountInLitre'
                  @input='liter'
                  :rules='[rulesLiter ,required]'
                  :disabled='!input.isEdit'
                  outlined
                  dense
                  type='number'
                  label='Литр'
              />
            </v-col>
            <v-col cols='12' md='6' sm='6'>
              <div class='parent'>
                <v-text-field
                    v-model.lazy='item.GrossPricePerTonne'
                    outlined
                    :rules='[rulesPriceLiterOrTons,required]'
                    type='number'
                    dense
                    :disabled='!input.isEdit'
                    @input='priceTons'
                    label='Цена за тонну'
                />
              </div>
            </v-col>
            <v-col cols='12' md='6' sm='6'>
              <div class='parent'>
                <v-text-field
                    v-model='item.GrossPricePerLitre'
                    outlined
                    :rules='[rulesPriceLiterOrTons,required]'
                    type='number'
                    dense
                    :disabled='!input.isEdit'
                    @input='priceLiter'
                    label='Цена за литр'
                >
                </v-text-field>
                <!--                <v-checkbox class='absalute'-->
                <!--                            v-model='item.ShowAmountInLitre'-->
                <!--                            hide-details-->
                <!--                            :disabled='!input.isEdit'-->
                <!--                            outlined-->
                <!--                            dense-->
                <!--                ></v-checkbox>-->
              </div>
            </v-col>
            <v-col cols='12' md='12' sm='12'>
              <v-radio-group
                  :disabled='!input.isEdit'
                  v-model='itemShowAmountInLitre'
                  row
              >
                <v-spacer></v-spacer>
                <v-radio
                    label='расчет в тоннах (не показывать литр)'
                    value='false'
                ></v-radio>
                <v-radio
                    label='расчет в тоннах (показывать литр)'
                    value='null'
                ></v-radio>
                <v-radio
                    label='расчет в литрах (показывать литр)'
                    value='true'
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-row>
      <v-col v-for='(result,index) of resultList' :key='index'
             cols='12' :md='result.title.style.md' :sm='result.title.style.sm'
      >
        <v-subheader class='sectionTitle'>
          {{ result.title.name }}
        </v-subheader>
        <v-divider></v-divider>
        <v-row>
          <v-col v-for='(obj,index) of result.items' :key='index'
                 cols='12' :md='obj.style.md' :sm='obj.style.sm'>
            <v-list-item tow-line>
              <v-list-item-content>
                <v-list-item-title :class='obj.class' class='itemValue'>
                  {{ info(obj) }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ obj.subtitle }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>


<script>

import { ProductCalc } from '@/utils/functions/Product'
import { num2str } from '@/utils/functions/MoneyFromString'
import {
  excise,
  totalPrice, totalPrice2,
  vatRate,
  density, liter, price, ton
} from '@/utils/filters/oil'
import { productsService } from '@/services/ProductsService'

const { appendixTotalCalculate } = require('~/utils/filters/oil')

export default {
  props: {
    input: Object,
    isTTN: Boolean,
    contract: Object,
    item: Object,
    getProduct: Function
  },
  data() {
    return {
      products: [],
      dataContract: {},
      panel: [0],
      itemShowAmountInLitre: false,
      required: value => {
        if (typeof value === 'boolean' || typeof value === 'number')
          return true
        else {
          return !!value || 'Поле обязательно для ввода'
        }
      },
      rulesDensity(density) {
        const number = parseFloat(density)
        if (isNaN(number)) return 'Разрешены Только числа'
        const numberStr = number.toString()
        const length = numberStr.length
        if (length > 5 && numberStr.includes('.')) return 'Максимальная длина после точки не может превышать 3 цифры'
        return (number <= 1 && number > 0) || 'Разрешенный числа больше нуля до одного'
      },
      rulesLiter(liter) {
        const number = parseFloat(liter)
        if (isNaN(number)) return 'Разрешены Только числа'
        const isFloat = liter.toString().includes('.')
        if (isFloat) return 'Разрешены Только целые числа'
        return true
      },
      rulesPriceLiterOrTons(priceLiterOrTons) {
        const number = parseFloat(priceLiterOrTons)
        if (isNaN(number)) return 'Разрешены Только числа'
        const strNumber = number.toString()
        const isFloat = strNumber.includes('.')
        if (isFloat) {
          const length = strNumber.split('.')[1].toString().length
          return length <= 2 || 'Максимальная длина после точки не может превышать 2 цифры'
        }
        return true
      },
      rulesTons(priceTons) {
        const number = parseFloat(priceTons)
        if (isNaN(number)) return 'Разрешены Только числа'
        const strNumber = number.toString()
        const isFloat = strNumber.includes('.')
        if (isFloat) {
          const length = strNumber.split('.')[1].toString().length
          return length <= 4 || 'Максимальная длина после точки не может превышать 4 цифры'
        }
        return true
      },
      resultList: [
        {
          title: { name: 'Товар', style: { md: '6', sm: '6' } },
          items: [
            {
              subtitle: 'Название',
              name: 'Name',
              action: null,
              style: { md: '6', sm: '6' }
            },
            {
              subtitle: 'Плотность',
              name: 'Density',
              action: density,
              style: { md: '6', sm: '6' }
            }
          ]
        },
        {
          title: { name: 'Количество', style: { md: '6', sm: '6' } },
          items: [
            {
              subtitle: 'Кол-во в тоннах',
              name: 'AmountInTonne',
              action: ton,
              style: { md: '6', sm: '6' }
            },
            {
              subtitle: 'Кол-во в литрах',
              name: 'AmountInLitre',
              action: liter,
              style: { md: '6', sm: '6' }
            }
          ]
        },
        {
          title: { name: 'Цена', style: { md: '6', sm: '6' } },
          items: [
            {
              subtitle: 'За тонну',
              name: 'GrossPricePerTonne',
              action: price,
              style: { md: '6', sm: '6' }
            },
            {
              subtitle: 'За литр',
              name: 'GrossPricePerLitre',
              action: price,
              style: { md: '6', sm: '6' }
            }
          ]
        },
        {
          title: { name: 'Акциз', style: { md: '6', sm: '6' } },
          items: [
            {
              subtitle: 'Ставка',
              name: 'tmpExcise',
              action: price,
              style: { md: '6', sm: '6' }
            },
            {
              subtitle: 'Сумма',
              name: 'Excise',
              action: excise,
              isObject: true,
              style: { md: '6', sm: '6' }
            }
          ]
        },
        {
          title: { name: 'Общая стоимость поставки', style: { md: '6', sm: '6' } },
          items: [
            {
              subtitle: '',
              name: 'total',
              action: price,
              class: 'totalPrice',
              style: { md: '6', sm: '6' }
            }
          ]
        },
        {
          title: { name: 'НДС', style: { md: '6', sm: '6' } },
          items: [
            {
              subtitle: 'Ставка',
              name: 'VATRate',
              action: vatRate,
              isObject: true,
              style: { md: '6', sm: '6' }
            }
          ]
        },
        {
          title: { name: 'Сумма с прописью', style: { md: '12', sm: '12' } },
          items: [
            {
              subtitle: '',
              name: 'total',
              prop: true,
              style: { md: '12', sm: '12' }
            }
          ]
        }
      ]
    }
  },
  async created() {
    this.dataContract = this.contract
    const products = await productsService.getAll()
    this.products = products.data
    this.product = this.item

    if (this.item.ShowAmountInLitre === null){
      this.itemShowAmountInLitre = "null"
    }else if(this.item.ShowAmountInLitre === false){
      this.itemShowAmountInLitre = "false"
    }else if(this.item.ShowAmountInLitre === true){
      this.itemShowAmountInLitre = "true"
    }

    if (this.contract?.HasVat === false) {
      this.item.VATRate = 0
    }
  },
  computed: {
    thisContract() {
      return this.contract
    },
    thisContractHasVat() {
      return this.contract?.HasVat
    }
    // checkNDS() {
    //   if (this.contract.HasVat === false) {
    //     return 'd-none'
    //   }
    // }
  },
  methods: {
    maxRate(maxRate) {
      if (!this.thisContractHasVat) return true
      const number = parseInt(maxRate)
      if (isNaN(number)) return 'Разрешены Только числа от 1 до 100'
      return (number > 0 && number <= 100) || 'Разрешены Только числа от 1 до 100'
    },
    resetItem() {
      this.product.GrossPricePerTonne = ''
      this.product.GrossPricePerLitre = ''
      this.product.AmountInTonne = ''
      this.product.AmountInLitre = ''
      this.product.NetPricePerTonne = 0
      this.product.PricePerTonneNoVAT = ''
      this.product.VATPerTonne = ''
      this.product.Density = 0
    },
    info(obj) {
      if (obj.action === null) {
        return this.item[obj.name]
      }
      if (obj.isSpectrial) {
        return obj.action(this.item)
      }
      if (obj.isObject) {
        return obj.action(this.item)
      }
      if (obj.prop) {
        this.item.TotalPriceInText = num2str(this.item.total)
        return this.item.TotalPriceInText
      }
      return obj.action(this.item[obj.name])
    },
    productChange(id) {
      const product = this.products.find(({ Id }) => Id === id)
      const contract = this.contract

      if (product && contract) {
        const HasPrivelege = contract.Buyer.HasPrivelege
        const prod = { ...product }
        prod.ProductId = product.Id || product.ProductId
        prod.tmpExcise = HasPrivelege ? 0 : prod.Excise
        this.product.VATRate = 0
        this.item.ProductId = prod?.ProductId
        this.item.tmpExcise = prod.tmpExcise
        this.item.AmountInLitre = ''
        this.item.AmountInLitre = ''
        this.item.GrossPricePerTonne = ''
        this.item.GrossPricePerLitre = ''
        this.item.NetPricePerTonne = 0
        this.item.PricePerTonneNoVAT = ''
        this.item.VATPerTonne = ''
        this.item.VATRate = 0
        this.item.Density = 0
        this.item.Name = prod?.Name
      }
    },
    density(den) {
      if (den === 0 || den < 0 || !den) {
        this.product.Density = 0
        return
      }
      this.item.GrossPricePerTonne = ''
      this.item.GrossPricePerLitre = ''
      this.item.AmountInTonne = ''
      this.item.AmountInLitre = ''
      this.item.NetPricePerTonne = 0
      this.item.PricePerTonneNoVAT = ''
      this.item.VATPerTonne = ''
      this.item.Density = den
      ProductCalc.density(this.item)
    },
    tons() {
      ProductCalc.setTons(this.item)
    },
    liter() {
      ProductCalc.setLiter(this.item)
    },
    priceLiter() {
      const liter = this.item.AmountInLitre
      const PriceLitre = this.item.GrossPricePerLitre
      const tone = this.item.AmountInTonne
      this.item.GrossPricePerTonne = parseFloat((liter * PriceLitre) / tone)
          .toFixed(2)
      this.item.total = parseFloat(liter * PriceLitre)
          .toFixed(0)
      return this.item.total
    },
    priceTons() {
      const tone = this.item.AmountInTonne
      const PriceTonne = this.item.GrossPricePerTonne
      const liter = this.item.AmountInLitre
      this.item.GrossPricePerLitre = parseFloat((tone * PriceTonne) / liter)
          .toFixed(0)
      this.item.total = parseFloat(tone * PriceTonne)
          .toFixed(0)
      return this.item.total
    }
  },
  watch: {
    itemShowAmountInLitre(val) {
      this.item.ShowAmountInLitre = val === 'null' ? null : (val === 'true')
    },
    'item.ShowAmountInLitre'(show) {
      this.itemShowAmountInLitre = show === null ? 'null' : (show ? 'true' : 'false');
      this.resetItem()
      if (show) {
        this.$emit('setTotal', this.priceLiter)
      } else {
        this.$emit('setTotal', this.priceTons)
      }
    },
    'item': {
      deep: true,
      immediate: true,
      handler(item) {
        const showAmount = item.ShowAmountInLitre
        const action = showAmount ? this.priceLiter : this.priceTons
        this.$emit('setTotal', action)
      }
    }
  }
}
</script>

<style>
.totalPrice {
  font-weight: bold;
  font-size: 25px;
}

.parent {
  position: relative;
}

.absalute {
  position: absolute;
  left: 100%;
  right: 0;
  top: -12px;
}
</style>
